import { UserEvent } from './user-event.model';

export class MarqueNotifLueEvent extends UserEvent {
  public static NAME = 'MARQUE_NOTIF_LUE_EVENT';

  constructor(public idAlerte: string) {
    super(MarqueNotifLueEvent.NAME);
  }

  public static hydrate(obj: MarqueNotifLueEvent): MarqueNotifLueEvent {
    return new MarqueNotifLueEvent(obj.idAlerte);
  }
}
